import { render, staticRenderFns } from "./loading.component.vue?vue&type=template&id=0d74345d&scoped=true"
import script from "./loading.component.vue?vue&type=script&lang=ts"
export * from "./loading.component.vue?vue&type=script&lang=ts"
import style0 from "./loading.component.vue?vue&type=style&index=0&id=0d74345d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d74345d",
  null
  
)

export default component.exports